export default __webpack_public_path__ + "static/char-s-11-chs-ab7af1bcb07c7dc219b42251eeaa03f2.webp";